// data
const listTransaksiEpayment = () => ({});
const listTopupEpayment = () => ({});
const listPaketEpaymentOwner = () => ({});
const infoTopupEpayment = () => ({});
const detailTopupEpayment = () => ({});

// filter
const pagination = () => ({
	limit: 20,
	offset: 0,
	length: 0,
	pageNumber: 0,
});

// search
const searchTopup = () => ({
	key: "",
});

const state = {
	listTransaksiEpayment: listTransaksiEpayment(),
	listTopupEpayment: listTopupEpayment(),
	listPaketEpaymentOwner: listPaketEpaymentOwner(),
	infoTopupEpayment: infoTopupEpayment(),
	detailTopupEpayment: detailTopupEpayment(),

	// pagination
	pagination: pagination(),

	// search
	searchTopup: searchTopup(),
	isSearchTopup: false,

	scrollPosition: 0,
}

export {
	state as default,
	listTransaksiEpayment,
	listTopupEpayment,
	listPaketEpaymentOwner,
	infoTopupEpayment,
	detailTopupEpayment,
	pagination,
	searchTopup,
}